export const RETRIEVE_QUOTE = 'RETRIEVE QUOTE';
export const FEATURE_FLAGS = {
    home_enabled: true,
    van_enabled: true,
    device_enabled: true,
    motor_enabled: true,
    travel_enabled: true
}
